<template>
  <div>
    <modal
      id="modalBoletim"
      :tamanho="'xl'"
      :exibir="exibir"
      @fechar="fecharModal"
      :titulo="titulo"
      :campos="$refs"
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col-xl-12">
            <span>
              *As faltas apresentadas aqui são os totais de faltas válidas
              conforme lançamento na tela de frequência
            </span>
            <b-table
              :fields="tabelaFields"
              :items="boletimDados"
              class="mt-3 position"
              show-empty
              sticky-header="400px"
              responsive="xl"
              :empty-text="$t('GERAL.NENHUM_REGISTRO')"
              head-variant="light"
              striped
            >
              <template #cell(media)="item">
                {{ item.item.boletim?.media ?? '-' }}
              </template>

              <template #cell(nota)="item">
                <div>
                  <b-input-group class="mt-3">
                    <div class="col-xl-12 flex">
                      <input-text
                        style="width: 100px"
                        class="mr-2 mb-2"
                        ref="nota"
                        v-model="item.item.nota"
                        type="number"
                        :max="100"
                        size="sm"
                      />
                    </div>
                  </b-input-group>
                </div>
              </template>

              <template #cell(faltasValidas)="item">
                <div>
                  <b-input-group class="mt-3">
                    <div class="col-xl-12 flex">
                      <input-text
                        style="width: 100px"
                        class="mr-2 mb-2"
                        ref="faltasValidas"
                        v-model="item.item.faltasValidas"
                        type="number"
                        :max="100"
                        size="sm"
                      />
                    </div>
                  </b-input-group>
                </div>
              </template>

              <template #cell(parecerValor)="cell">
                <b-form-select
                  v-model="cell.item.parecerValor"
                  :options="parecerOptions"
                  size="sm"
                  class="mt-2 mb-2"
                />
              </template>
            </b-table>
          </div>
        </div>
      </div>

      <template #modal-footer>
        <div class="w-100 d-flex justify-content-between">
          <b-button variant="secondary" @click="fecharModal">
            {{ $t('GERAL.FECHAR') }}
          </b-button>
          <b-button
            class="ml-2"
            variant="primary"
            @click="salvar"
            v-if="podeCadastrar"
          >
            {{ $t('GERAL.SALVAR') }}
          </b-button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import Permissoes from '@/components/mixins/permissoes';

import BoletimService from '@/common/services/boletim/boletim.service';
import { InputText } from '@/components/inputs/index';

import Modal from '@/components/modal/Modal.vue';
import { BFormSelect } from 'bootstrap-vue';

export default {
  mixins: [Permissoes],
  name: 'ModalBoletim',
  components: {
    Modal,
    InputText,
    BFormSelect,
  },
  props: {
    form: { type: Object, default: () => {} },
    filtro: { type: Object, default: () => {} },
    exibir: { type: Boolean, default: true },
  },
  watch: {
    exibir(newVal) {
      if (newVal) {
        this.obterBoletimPorFiltro();
      }
    },
  },
  data() {
    return {
      boletimDados: [],
      boletinsAtualizados: [],
      editar: '',
      editarFalta: '',
      parecerOptions: [
        { value: null, text: this.$t ? this.$t('GERAL.SELECIONE') : 'Selecione' },
        { value: 'APR', text: 'Aprovado' },
        { value: 'RPV', text: 'Reprovado' },
      ],
    };
  },
  computed: {
    titulo() {
      const nome = !this.form?.nomeAluno ? '' : this.form.nomeAluno;
      return this.$t('Boletim: ' + `${nome}`);
    },

    tabelaFields() {
      const fields = [
        {
          key: 'disciplina.descricao',
          label: 'Disciplina',
          sortable: true,
        },

        {
          key: 'media',
          label: 'Média final',
          sortable: true,
        },

        {
          key: 'boletim.totalFaltas',
          label: 'Faltas totais',
          sortable: true,
        },

        {
          key: 'nota',
          label: 'Média',
          sortable: true,
        },

        {
          key: 'parecerValor',
          label: 'Parecer descritivo',
          sortable: true,
        },

        {
          key: 'faltasValidas',
          label: 'Faltas',
          sortable: true,
        },
      ];

      return fields;
    },
  },
  methods: {
    habilitarEdicao(index) {
      this.editar = index;
    },

    habilitarEdicaoFalta(index) {
      this.editarFalta = index;
    },

    obterBoletimPorFiltro() {
      this.$store.dispatch(START_LOADING);
      BoletimService.obterBoletinsPorFiltro({
        ...this.filtro,
        matriculaId: this.form.matriculaId,
      })
        .then(({ data }) => {
          this.boletimDados = data;

          this.boletimDados.forEach((item) => {
            if (item.boletim?.media != null && !isNaN(item.boletim.media)) {
              item.boletim.media = Number(item.boletim.media).toFixed(1);
            }

            const status =
              item.statusParecerDescritivo ??
              item.boletim?.statusParecerDescritivo ??
              null;

            if (status === 'APR' || status === 'RPV') {
              item.parecerValor = status; // "APR" ou "RPV"
            } else {
              item.parecerValor = null;
            }
          });
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    atualizarBoletim(atualizados) {
      this.boletinsAtualizados = atualizados;
    },

    salvar() {

    const boletinsAtualizados = this.boletimDados.map((item) => {
      return {
        id: item.id,
        codigo: item.codigo,
        faltasValidas: item.faltasValidas,
        nota: item.nota,
        matriculaId: item.matriculaId ?? this.form.matriculaId,
        disciplinaId: item.disciplinaId ?? item.boletim?.disciplinaId,
        segmentacaoId: item.segmentacaoId,
        turmaId: this.filtro.turmaId,
        anoLetivoId: this.filtro.anoLetivoId,
        statusParecerDescritivo: item.parecerValor ?? null,
        editadoManualmente: true,
      };
    });

    const dadosNegativos = boletinsAtualizados.some(
      (item) => item.faltasValidas < 0 || item.nota < 0
    );

    if (dadosNegativos) {
      mensagem.erro(
        this.$t('GERAL.ERRO'),
        'Não é possível enviar faltas ou notas negativas'
      );
      return;
    }

    this.$store.dispatch(START_LOADING);

    BoletimService.criarListaBoletins(boletinsAtualizados)
      .then(() => {
        mensagem.sucesso(this.$t('GERAL.SUCESSO'), 'Boletins atualizados');
        this.fecharModal();
      })
      .catch((err) => {
        mensagem.showErrors(err);
      })
      .finally(() => {
        this.$store.dispatch(STOP_LOADING);
      });
    },

    fecharModal() {
      this.$emit('fechar');
    },
  },
};
</script>

<style>
.position thead {
  position: relative;
  z-index: 300;
}
.position th {
  width: 800px;
  padding: 10px;
}
.position th div {
  text-align: left;
  padding-left: 10px;
}
.position td {
  width: 800px;
  padding: 0px 5px;
}

td .input-group {
  height: auto !important;
  margin: 0px !important;
}

table td,
table th,
.table td,
.table th {
  padding: 0px 12px;
}

.position td {
  max-width: 90px;
}

.btnBoletim {
  height: 35px;
  position: absolute;
  z-index: -300;
  margin-top: 7px;
}

.flex {
  display: flex;
}
</style>
